<script setup lang="ts">
import { ProductSorting, ProductStatus } from "mws-ts-v2-sdk";

const translateSortLabel = useTranslateSortLabel();

const { availableFilters, type } = defineProps<{
  isAuctionsEnabled: boolean;
  type: "event" | "search" | "category";
  availableFilters?: FilterResponse;
}>();

useTrackAppliedProductFilters(
  () => type,
  () => availableFilters,
);
</script>

<template>
  <div data-test="product-filter-section">
    <BaseFilterSection
      unique-name="sort"
      type="single"
      :label="$t('sort.title')"
      :default-value="ProductSorting.Featured"
      :options="[
        {
          label: $t('sort.featured'),
          value: ProductSorting.Featured,
        },
        ...(isAuctionsEnabled
          ? [
              {
                label: translateSortLabel('closing', 'earliest', 'latest'),
                value: ProductSorting.ClosingTimeFirstToLast,
              },
              {
                label: translateSortLabel('closing', 'latest', 'earliest'),
                value: ProductSorting.ClosingTimeLastToFirst,
              },
            ]
          : []),
        {
          label: translateSortLabel('pricing', 'highest', 'lowest'),
          value: ProductSorting.PriceHighToLow,
        },
        {
          label: translateSortLabel('pricing', 'lowest', 'highest'),
          value: ProductSorting.PriceLowToHigh,
        },
      ]"
    />

    <BaseFilterSection
      v-if="isAuctionsEnabled && type === 'search'"
      unique-name="productStatus"
      type="single"
      label="Status"
      default-value="all"
      :options="[
        {
          label: $t('filter.status.all'),
          value: 'all' as string,
        },
        {
          label: $t('filter.status.live'),
          value: ProductStatus.Live,
        },
        {
          label: $t('filter.status.finished'),
          value: ProductStatus.Finished,
        },
      ]"
    />

    <ProductFilterPrice
      v-if="availableFilters?.minimumPrice && availableFilters.maximumPrice"
      :minimum-price="availableFilters.minimumPrice"
      :maximum-price="availableFilters.maximumPrice"
    />

    <template v-if="availableFilters?.categoryFilters">
      <BaseFilterSection
        v-for="(options, category) in availableFilters.categoryFilters"
        :key="category"
        unique-name="category"
        type="multiple"
        :label="$t(`category.types.${category}`)"
        :options="options"
      />
    </template>

    <BaseFilterSection
      v-if="isAuctionsEnabled && type !== 'search'"
      unique-name="productStatus"
      type="single"
      label="Status"
      default-value="all"
      :options="[
        {
          label: $t('filter.status.all'),
          value: 'all' as string,
        },
        {
          label: $t('filter.status.live'),
          value: ProductStatus.Live,
        },
        {
          label: $t('filter.status.finished'),
          value: ProductStatus.Finished,
        },
      ]"
    />
  </div>
</template>
